// extracted by mini-css-extract-plugin
export default {"dashboard":"x5_LIM","dashboard__logo":"J9ZzK1","dashboardLogo":"J9ZzK1"};